module.exports = __webpack_public_path__ + "static/media/50.bab451cf.png";